import type { ReactNode } from "react";
import CreateAccountForm from "../components/create-account";
import PageLayout from "./layout";

export default function SignupPage(): ReactNode {
  return (
    <PageLayout title="Create Account">
      <section
        className="flex-none m-0 flex justify-center bg-cover bg-center"
        style={{
          background:
            "linear-gradient(90deg, rgb(0 0 0 / 0.5), rgb(0 0 0 / 0.3)), url(\"/images/bg3.webp\") center / cover",
        }}
      >
        <div className="text-white w-full max-w-200 py-16">
          <h1 className="border-b-0 text-white text-4xl m-0">Create a Free Account</h1>
          <p className="text-white text-xl my-[0.8rem]">
            Start accessing financial data APIs in minutes
          </p>
        </div>
      </section>

      <section className="flex-none m-0 px-8 py-16 bg-[#f9f9fb]">
        <div className="max-w-2xl mx-auto bg-white border border-[#eee] rounded-lg shadow-[0_2px_8px_rgb(0_0_0/0.06)] p-12">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-[#1a1a2e] m-0 mb-2">Get started for free</h2>
            <p className="text-[#666] text-base m-0">Create your account and start integrating financial data APIs today. No credit card required.</p>
          </div>
          <CreateAccountForm/>
        </div>
      </section>
    </PageLayout>
  );
}
